import React, { useState, useEffect, useCallback } from 'react';
import Css from './Css.js';
import './index.scss'
import TopMenu from './TopMenu/TopMenu.js';
import VibrationBox from './VibrationBox/VibrationBox.js';
import PatternBox from './PatternBox/PatternBox.js';
import ControlBox from './ControlBox/ControlBox.js';
import Confirm from './Dialog/Confirm/Confirm.js';
import Message from './Dialog/Message/Message.js';
import QrCode from './QrCode/QrCode.js';
import UnSync from './UnSync/UnSync.js';
import orderUtil from './Utils/orderUtil.js';
import FormatTime from './Utils/TimeFormat.js';
import Api from './Api/Api.js';
import SocketEvent from './Api/SocketEvent.js';
import { changeLanguage } from "./Utils/i18n/i18next.js";
import { useTranslation } from 'react-i18next';
import axios from 'axios';
axios.defaults.headers.post['Content-Type'] = 'application/json';

//Pattern编辑器组件
function Editor(props) {
  const {t} = useTranslation();
  const videoEl = props.editorInfo.videoEl;
  const role = props.editorInfo.role;
  const editor_status = orderUtil.getParam("editor_status") === "true" ?true:false;
  let uid = "muuMU7RuNBBqTbo2CrTQWA==";
  if(props.editorInfo.uid){
    uid = props.editorInfo.uid;
  }
  let pf = "lovense";
  if(props.editorInfo.pf){
    pf = props.editorInfo.pf;
  }
  
  //m默认t9、t10平台是日语
  useEffect(()=>{
    if(pf === 't9' || pf === 't10'){
      changeLanguage('ja');
    }
    
  }, [pf]);

  let videoId = "id20210608";
  if(props.editorInfo.videoId){
    videoId = props.editorInfo.videoId
  }
  let speed = 1;
  let tmpSpeed = props.editorInfo.speed;
  if(tmpSpeed){
    speed = tmpSpeed;
  }
  const [playSpeed, setPlaySpeed] = useState({speed:speed});
  let socketServiceInstanct = props.socketServiceInstanct;
  let editorWidth = props.editorInfo.editorWidth;
  if(editorWidth < 720){
    editorWidth = 720; //限制编辑器最小宽度720px
  }
  const lvsPatternEditorId = props.editorInfo.lvsPatternEditorId;
  const [dialogConfig, setDialogConfig] = useState(null);
  const [msgConfig, setMsgConfig] = useState({ msg:"",width:editorWidth });
  //视频总时长(毫秒)
  const [videoTotalTime, setVideoTotalTime] = useState(0);
  //选区开始时间，结束时间
  let [selStartTime, setSelStartTime] = useState(0);
  const [selEndTime, setSelEndTime] = useState(0);
  useEffect(()=>{
    setVideoTotalTime(videoEl.duration*1000);
    setSelEndTime(videoEl.duration*1000);
  }, [videoEl.duration]);
  
  const editorEl = document.getElementById(lvsPatternEditorId);
  //视频信息：play:0暂停，1播放  progress:播放进度 time:视频时长
  const [progress, setProgress] = useState(0);
  //计算中间区域宽度
  let leftWidth = 160;
  if(editorWidth < 960 && editorWidth >= 720){
    leftWidth = 80;
    orderUtil.controlBoxWidth = 140;
  }
  const middleWidth = editorWidth - leftWidth - orderUtil.controlBoxWidth - 4;
  //鼠标滑轴选区计算
  const [timeLinePosition, setTimeLinePosition] = useState({ width: middleWidth, left:0, right:0 });
  //播放进度滑块
  const [level, setLevel] = useState(0);       //震动强度
  const [isPlay, setIsPlay] = useState(false); //视频是否播放
  //是否网络卡顿导致视频播放暂停
  const [isWaiting, setIsWaiting] = useState({waiting:false,t:0});
  //pattern数据点
  const [points, setPoints] = useState([]);
  //进入编辑模式之前的数据备份
  const [backupPoints, setBackupPoints] = useState([]);
  //最后一次保存的数据
  const [lastSavePoints, setLastSavePoints] = useState([]);
  //是否有点击submit
  const [hasSubmitPattern, setHasSubmitPattern] = useState(false);
  //pattern数据
  const [patternInfo, setPatternInfo] = useState({id:null,url:""});
  //连接的玩具
  const [toys, setToys] = useState([]);
  
  const getPattern = useCallback(
    async () => {
      let url = Api.getPattern + "?videoId=" + videoId + "&pf=" + pf;
      let res = await axios.get(url);
      if(res.data && res.data.code === 0){ //已存在pattern，则显示曲线
        let patternUrl = res.data.data.pattern;
        setVideoHasPattern({hasPattern:true});
        setPatternInfo({id:res.data.data.id, url:res.data.data.relativePattern});
        //下面加载并渲染出pattern曲线可能比较耗时，todo：loading优化加载数据
        axios.get(patternUrl).then(function(res2){ //获取pattern曲线数据
          let arr = res2.data;
          setPoints(arr);
          setTimeLinePosition({ width:middleWidth, left: 0 });
          setTimeScaleInfo({
            selStartTime: 0,
            selEndTime: videoTotalTime,
            selTime: videoTotalTime >= 500 ? videoTotalTime : 500,
            videoTotalTime,
            middleWidth,
            width: 0, 
            slideBtn: "right"
          })
          setSelStartTime(0)
          setSelEndTime(videoTotalTime)
        })
      }else{
        setVideoHasPattern({hasPattern:false});
      }
    }, [videoId, pf, middleWidth, videoTotalTime]
  )
  //查询当前视频是否已经存在pattern
  useEffect(()=>{
    getPattern();
  }, [getPattern])

  const editorCanvasId = lvsPatternEditorId + "_canvas";
  let editorCanvas = document.getElementById(editorCanvasId);
  //时间刻度计算
  let selTime = selEndTime;
  const [timeScaleInfo, setTimeScaleInfo] = useState({
    selStartTime: 0,
    selEndTime,
    selTime: selTime >= 500 ? selTime : 500,
    videoTotalTime,
    middleWidth,
    width: 0, 
    slideBtn: "right"
  });
  //编辑器模式：1创建，2编辑，3预览
  const [editorMode, setEditorMode] = useState({edMode:1});
  let qrCodeDataTmp = null;
  let editorStatusTmp = 1;
  let isMobile = props.editorInfo.isMobile;
  if(!isMobile){
    if(props.editorInfo.showCustomerQrcode){
      qrCodeDataTmp = { type:2,w:editorWidth,h:orderUtil.patternEditorHeight,videoId,uid,pf };
      editorStatusTmp = 3;
    }
  }
  //1显示create或play按钮，2显示编辑器，3显示二维码 4显示同步控制
  const [editorStatus, setEditorStatus] = useState({edStatus: editorStatusTmp});
  //玩具连接状态 1未连接 2连接中 3连接成功 4连接失败 5app异常断开
  const [connectToyStatus, setConnectToyStatus] = useState({ctStatus:0});
  //是否已存在跟随的pattern
  const [followPattern, setFollowPattern] = useState({follow: false});
  //扫码页面
  const [qrCodeData, setQrCodeData] = useState(qrCodeDataTmp);
  const [videoHasPattern, setVideoHasPattern] = useState({hasPattern:false});
  //记录选择复制粘贴区域的蒙版div信息
  const [sldivPosition, setSldivPosition] = useState({ width:0,marginLeft:0,divStartTime:0,divEndTime:0,show:false });
  //是否进入复制粘贴模式
  const [isSelectLine, setIsSelectLine] = useState(false);
  //记录复制粘贴功能中批量选中的点
  const [batchSelPointPositionArr, setBatchSelPointPositionArr] = useState([]);
  const [selEditPointsArr, setSelEditPointsArr] = useState([]);
  //是否显示复制粘贴菜单
  const [editMenuInfo, setEditMenuInfo] = useState({"show":false, "btn":"clear,copy,paste,cancel", "menuLeft":0});
  //复制选区内的点
  const [copyArr, setCopyArr] = useState([]);
  //记录按下的是鼠标左键还是右键
  const [mouseDownType, setMouseDownType] = useState("");
  //可选的最大和最小震动等级，默认0-20
  const [levelRange, setLevelRange] = useState({min:0,max:20});

  //在Audiodesires_demo页，用户主动刷新或者关闭网页时需要主动断开连接
  window.userClosePage = function () {
    exitSync()
  }
  //埋点上报
  const createRecord = useCallback(
    (eventStr) => {
    let osInfo = orderUtil.getOsInfo();
    let param = JSON.stringify({
      videoId: videoId,
      pf: pf,
      uid: uid,
      videoDuration: parseInt(videoEl.duration),
      videoUrl: window.location.href,
      videoName: "",
      system: osInfo.name + " " + osInfo.version,
      browser: osInfo.browser,
      eventId: eventStr,
    });
    axios.post(Api.createRecord, param).then(function (res) {
      if(res.data && res.data.code === 0){ }
    });
  }, [pf,uid,videoEl,videoId]);
  //观众主动退出同步播放pattern
  const exitSync = () => {
    sendPcExitPatternSyncDto();
    setConnectToyStatus({ctStatus:1});
    setEditorStatus({edStatus:1});
  }
  //告诉remote重新下载pattern并尝试同步pattern
  const retrySync = () => {
    socketServiceInstanct.socketEmitMsg(SocketEvent.RetrySyncPatternDTO, {});
  }
  //唤起app
  const [evokeAppUrl, setEvokeAppUrl] = useState({evokeUrl:""});
  useEffect(()=>{
    let param = JSON.stringify({
      videoId: videoId,
      uid: uid,
      pf: pf,
      type: 2,
    });
    axios.post(Api.getQrCode, param).then(function (response) {
      const res = response.data;
      if(res && res.code === 0){
        let u = navigator.userAgent;
        let isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
        if(isWeixin){
          alert("Please open in your browser!");
          return;
        }
        let url = "https://lovense.club/remote/camapi/vpEvokeApp.html?vpCode=" + res.data.code + "&time=5000";
        setEvokeAppUrl({evokeUrl:url});
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }, [videoId,uid,pf])
  const [diffTime, setDiffTime] = useState(0);
  useEffect(()=>{
    let url = process.env.REACT_APP_API_GETTIMESTAMP;
    //注：同步时间的这两个接口目前只能写死，需与app保持相同
    let localTimeStamp = (new Date()).getTime();
    // console.log("请求之前的本地时间：", localTimeStamp);
    axios.get(url).then(function(res){
      if(res.data.result){
        let localTimeStamp2 = (new Date()).getTime();
        // console.log("请求之后的本地时间：", localTimeStamp);
        let axiosRequestTime = parseInt((localTimeStamp2 - localTimeStamp)/2);
        // console.log("网络请求花费的时间：", axiosRequestTime);
        let serverTime = res.data.data;
        // console.log("服务器的时间：", serverTime);
        let localJzTime = localTimeStamp + axiosRequestTime;
        // console.log("本地时间与服务器时间校准后的时间：", localJzTime);
        let t = (serverTime - localJzTime);
        setDiffTime(t);
        // console.log("本地与服务器的时间差异：", t);
      }
    })
  }, []);
  const closeQrCode = () => {
    
    if(qrCodeData.type === 2){
      setEditorStatus({edStatus:1});
    }
    setQrCodeData(null);
    if (pf==="Audiodesires_demo") {
      setTimeout(() => {
        var hashH = document.documentElement.offsetHeight; //获取自身高度
        window.parent.postMessage(hashH, "*");
      }, 200);
    } 
  }
  //点击create按钮
  const showEditor = () => {
    videoEl.pause();
    setEditorStatus({edStatus:2});
    getPattern();
  }
  //点击play按钮
  const playPattern = () => {
    videoEl.pause();
    socketServiceInstanct.getSyncStatus(1); //查询跟随状态
    if(followPattern.follow){
      //当前已经是跟随状态，则直接切换跟随的pattern
      socketServiceInstanct.socketEmitMsg(SocketEvent.ModifyVideoPatternDTO, {});
    }else{
      createRecord('sync_a_lovense_toy');
      if(isMobile){
        console.error("理论上不会出现这种情况，因为ios的唤醒app已经使用a标签处理！");
      }else{
        setEditorStatus({edStatus:0});
        setQrCodeData({ type:2,w:editorWidth,h:orderUtil.patternEditorHeight,videoId,uid,pf });
        createRecord('get_qrcode');
      }
      if (pf==="Audiodesires_demo") {
        setTimeout(() => {
          var hashH = document.documentElement.offsetHeight; //获取自身高度
          window.parent.postMessage(hashH, "*");
        }, 200);
      } 
    }
  }
  useEffect(()=>{
    if (pf==='Audiodesires_demo') {
      if (isMobile) {
        
        setTimeout(() => {
          var hashH = document.documentElement.offsetHeight; //获取自身高度
          window.parent.postMessage(hashH, "*");
        }, 200);
        let sUserAgent = navigator.userAgent.toLowerCase();
    let bIsIphoneOs = sUserAgent.match(/iphone os/i) === "iphone os";
        if (evokeAppUrl.evokeUrl) {
          createRecord('sync_a_lovense_toy');
          if (bIsIphoneOs) {
            window.demoBtnOpenUrl.location.replace(evokeAppUrl.evokeUrl)
            setTimeout(() => {
              window.demoBtnOpenUrl.close();
            }, 200);
          } else {
            window.demoBtnOpenUrl.location = evokeAppUrl.evokeUrl
          }
          
        }
      }
    }
  },[pf,isMobile,evokeAppUrl,createRecord])
  let elSpan10 = document.getElementById("lvsPatternEditorId_event_610");
  if(elSpan10){
    elSpan10.addEventListener("click", ()=>{ 
      if (pf==='Audiodesires_demo'&&!isMobile) {
        playPattern()
      }
      
    });
    document.body.removeChild(elSpan10);
  }
  useEffect(() => {
    if(!isPlay) return;
    //同步视频播放与pattern的进度
    //由于video标签的timeupdate监听事件不够实时，大约0.25s才调用一次
    //故本地再搞个定时器更精确地计算播放进度
    const playTimer = setInterval(()=>{
      setProgress(progress => progress + 20);
      // 时间轴选区跟随视频播放滑动
      if(progress > selEndTime){
        let cTime = progress - selEndTime;
        let cStartTime = (selStartTime + cTime) >= 0 ? (selStartTime + cTime) : 0;
        setSelStartTime(cStartTime);
        setSelEndTime(progress);
        let hzLeft = (selStartTime/videoTotalTime)*middleWidth;
        setTimeLinePosition({ ...timeLinePosition,left:hzLeft>0?hzLeft:0 });
      }
    }, 20);

    return function(){
      if(!isPlay) {
        return;
      }
      clearInterval(playTimer);
    }
  }, [isPlay,progress,selStartTime,selEndTime,timeLinePosition,middleWidth,videoTotalTime])
  useEffect(()=>{
    const keyUpFunc = () => {
      if(editorEl){
        editorEl.onmousemove = null;
      }
      setMouseDownType("");
    }
    window.document.addEventListener("mouseup", keyUpFunc);
    return function(){
      window.document.removeEventListener('mouseup', keyUpFunc);
    }
  },[editorEl])
  //隐藏复制粘贴相关操作
  const hideCopyPaste = ()=>{
    setEditMenuInfo({...editMenuInfo, "show":false});
    setSldivPosition({...sldivPosition, "show":false});
    setBatchSelPointPositionArr([]);
    setSelEditPointsArr([]);
    setIsSelectLine(false);
  }
  //连接玩具
  const connectToyEvent = () => {
    if(connectToyStatus.ctStatus !== 3){
      setQrCodeData({ type:1,w:editorWidth,h:orderUtil.patternEditorHeight,videoId,uid,pf });
      createRecord('get_qrcode');
    }
  }
  //预览
  const goPreview = () => {
    videoEl.pause();
    if(points.length <= 0){
      setMsgConfig({...msgConfig, msg:"Please create a pattern first!"});
      return;
    }
    if(editorMode.edMode === 3){ //退出预览模式
      setEditorMode({edMode:1});
      let lastPointTime = points[points.length-1].t;
      setProgress(lastPointTime);
      let type = SocketEvent.StartPreviewModeDTO;
      let data = { pattern:patternInfo.url, status:false, isDownload:false };
      socketServiceInstanct.socketEmitMsg(type, data);
      return;
    }
    if(connectToyStatus.ctStatus === 3){ //进入预览模式
      let isPreview = true;
      submitPattern(isPreview);
      createRecord('preview_click');
    }else{
      setQrCodeData({ type:1,next:"preview",w:editorWidth,h:orderUtil.patternEditorHeight,videoId,uid,pf });
      createRecord('get_qrcode');
    }
  }
  //点击Edit Mode
  const goEdit = () => {
    videoEl.pause();
    setEditorMode({edMode:2});
    let bkArr = orderUtil.deepClone(points);
    setBackupPoints(bkArr);
    createRecord('edit_mode_click');
  }
  const exitEdit = () => {
    setEditorMode({edMode:1});
  }
  //点击Exit
  const closeEditor = () => {
    videoEl.pause();
    if(points.length === 0){
      sendPcExitPatternSyncDto();
      setEditorStatus({edStatus:1}); 
      return;
    }
    let str1 = JSON.stringify(points);
    let str2 = JSON.stringify(lastSavePoints);
    if(str1 !== str2 || !hasSubmitPattern){
      let obj = {
        type: "promptToSavePattern",
        show: true,
        editorWidth: editorWidth,
        msg: "Do you want to submit your pattern?",
        btn0: "Cancel",
        btn1: "Exit",
        btn2: "Submit and Exit"
      }
      setDialogConfig(obj);
      return;
    }else{
      sendPcExitPatternSyncDto();
      setEditorMode({edMode:1});
      setMsgConfig({ ...msgConfig, msg:"" });
      setEditorStatus({edStatus:1});
    }
  }
  const showSubmitDia = () => {
    videoEl.pause();
    let obj = {
      type: "submitPattern",
      show: true,
      editorWidth: editorWidth,
      msg: "Do you want to submit your pattern?"
    }
    setDialogConfig(obj);
  }
  const confirmYes = async () => {
    if(dialogConfig.type === "exitEditor"){  //确认退出编辑器
      setMsgConfig({ ...msgConfig, msg:"" });
      setEditorStatus({edStatus:1});
    }else if(dialogConfig.type === "submitPattern"){  //确认提交pattern
      let isPreview = false;
      submitPattern(isPreview);
      setHasSubmitPattern(true);
    }else if(dialogConfig.type === "exitEditMode"){  //确认退出编辑模式并保存编辑数据
      setEditorMode({edMode:1});
      setDialogConfig({msg:""});
    }else if(dialogConfig.type === "promptToSavePattern"){
      sendPcExitPatternSyncDto();
      submitPattern(false, 'exit');
    }
  }
  const confirmCancel = () => {
    if(dialogConfig.type === "exitEditMode"){ //确认退出编辑模式且不保存编辑数据（即还原到编辑之前的数据）
      setPoints([...backupPoints]);
      setEditorMode({edMode:1});
      setDialogConfig({msg:""});
    }else if(dialogConfig.type === "promptToSavePattern"){
      setDialogConfig({msg:""});
    }else{
      setDialogConfig({msg:""});
    }
  }
  const confirmExit = () => {
    sendPcExitPatternSyncDto();
    setEditorStatus({edStatus:1});
    setEditorMode({edMode:1});
    setDialogConfig({msg:""});
  }
  const sendPcExitPatternSyncDto = () => {
    setConnectToyStatus({ctStatus:1});
    setEditorStatus({edStatus:1});
    socketServiceInstanct.socketEmitMsg(SocketEvent.PcExitPatternSyncDTO, {});
  }
  //创建提交pattern
  const submitPattern = (preview, isExit="") => {
    setDialogConfig( {msg:""} );
    if(points.length <= 0){
      setMsgConfig({ ...msgConfig,msg:"Pattern data can not be empty!" });
      return;
    }
    uploadPattern(points, preview, isExit);
  }

  const uploadPattern = useCallback(
    (patternData, preview, isExit) => {
      let isDownload = true;
      let previewMode = false;
      if(preview){
        videoEl.pause();
        previewMode = editorMode.edMode === 3 ? false : true;
        if(previewMode){
          setEditorMode({edMode:3});
        }else{
          setEditorMode({edMode:1});
        }
        let str1 = JSON.stringify(points);
        let str2 = JSON.stringify(backupPoints);
        if((str1 === str2 || backupPoints.length === 0) && hasSubmitPattern){
          // isDownload = false;
          isDownload = true; //123
        }
        if(!isDownload){
          let type = SocketEvent.StartPreviewModeDTO;
          let data = { pattern:patternInfo.url,status:previewMode, isDownload:isDownload };
          socketServiceInstanct.socketEmitMsg(type, data);
          return;
        }
      }
      var formData = new FormData();
      formData.append('uid', uid);
      formData.append('pf', pf);
      formData.append('loadType','LovenseEditor');
      formData.append('file', new File([JSON.stringify(patternData)], ""));
      axios.post(Api.uploadPattern, formData).then(function (res) {
        if(res.data && res.data.code === 0){
          let tmpUrl = res.data.data.fileUrl;
          if(preview){  //预览模式，需同步播放进度
            if(socketServiceInstanct){
              let type = SocketEvent.StartPreviewModeDTO;
              let data = { pattern:tmpUrl, status:previewMode, isDownload:isDownload };
              socketServiceInstanct.socketEmitMsg(type, data);
            }
            return;
          }
          if(patternInfo.id){  //编辑
            let param = JSON.stringify({
              patternId: patternInfo.id,
              pattern: tmpUrl,
              pf: pf,
              uid: uid,
              loadType:'LovenseEditor'
            });
            axios.post(Api.editPattern, param).then(function (res2) {
              if(res2.data.code === 0){
                let bkArr = orderUtil.deepClone(points);
                setBackupPoints(bkArr);
                setLastSavePoints(bkArr);
                if(isExit === 'exit' && editorMode.edMode === 3){
                  setEditorMode({edMode:1});
                  setConnectToyStatus({ctStatus:1});
                }
                setMsgConfig({...msgConfig,type:isExit,time:2000,msg:"Pattern submitted successfully!"});
              }
            })
            .catch(function (error) {
              console.log(error);
            });
          }else{  //新增
            let osInfo = orderUtil.getOsInfo();
            let patternTotalTime = parseInt(points[points.length-1].t/1000);
            let tFormat = FormatTime(patternTotalTime, "HH:mm:ss");
            let param = JSON.stringify({
              pattern: tmpUrl,
              videoId: videoId,
              pf: pf,
              uid: uid,
              videoDuration: videoEl.duration,
              videoUrl: window.location.href,
              name: "",
              duration: patternTotalTime,
              time: tFormat,
              videoName: "",
              system: osInfo.name + " " + osInfo.version,
              browser: osInfo.browser,
            });
            axios.post(Api.createPattern, param).then(function (res2) {
              if(res2.data && res2.data.code === 0){
                let bkArr = orderUtil.deepClone(points);
                setBackupPoints(bkArr);
                setLastSavePoints(bkArr);
                setPatternInfo({...patternInfo, id:res2.data.data.id, url:tmpUrl});
                setTimeout(()=>{
                  setMsgConfig({...msgConfig,type:isExit,time:2000,msg:"Pattern submitted successfully!"});
                }, 100);
                createRecord("create_pattern_into");
              }else{
                setTimeout(()=>{
                  setMsgConfig({...msgConfig,time:2000,msg:"Failed to submit pattern, please try again!"});
                }, 100);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
          }
        }else{
          setMsgConfig({...msgConfig,msg:res.msg});
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },[backupPoints,createRecord,editorMode,hasSubmitPattern,msgConfig,patternInfo,pf,points,socketServiceInstanct,uid,videoEl,videoId])

  const closeMsg = () => {
    setMsgConfig({...msgConfig,msg:""});
  }
  const closeAndExit = () => {
    setMsgConfig({...msgConfig,msg:""});
    setEditorStatus({edStatus:1});
  }
  //绑定自定义右键菜单
  useEffect(()=>{



    const createRightMenu = (e) => {
      e.preventDefault();
      if(editorMode.edMode === 2){
        const clickX = e.clientX;
        let editorLeft = document.getElementById(lvsPatternEditorId).getBoundingClientRect().left;
        let xLeft = clickX - editorLeft - 160 - 6;
        let menuLeft = xLeft;
        let btns = "";
        if(copyArr.length > 1){
          if(sldivPosition.show){
            if(selEditPointsArr.length > 1){
              btns = "clear,copy,cancel";
            }else{
              btns = "paste,cancel";
            }
          }else{
            btns = "paste,cancel";
          }
        }else if(selEditPointsArr.length > 1 && sldivPosition.show){
          btns = "clear,copy,cancel";
        }
        setEditMenuInfo({"show":true, "btn":btns, menuLeft});
      }
    }
    if(editorCanvas){
      editorCanvas.addEventListener('contextmenu', createRightMenu);
    }
    return function(){
      if(editorCanvas){
        editorCanvas.removeEventListener('contextmenu', createRightMenu)
      }
    }
  },[editorCanvas,lvsPatternEditorId,editorMode,copyArr,sldivPosition,selEditPointsArr])

  //编辑模式，寻找鼠标附近的关键点
  const [editPointPositionArr, setEditPointPositionArr] = useState([]);
  const pauseVideo = () => {
    videoEl.pause();
  }
  const [sameLevelTime, setSameLevelTime] = useState(0); //用于记录相邻点连续相同震动等级的次数
  //remote下载pattern状态  2：下载失败
  const [remoteDnPattern, setRemoteDnPattern] = useState({rdnStatus:0,videoId:""});
  let [sendVideoInfoTimer, setSendVideoInfoTimer] = useState({hasViTimer:false});
  let [vpsTimer, setVpsTimer] = useState(null);

  //显示批量选中的点
  const showCopyPoints = (width, marginLeft)=>{
    let w1 = 0;
    let w2 = 0;
    if(width){
      w1 = marginLeft;
      w2 = width + marginLeft;
    }else{
      w1 = sldivPosition.marginLeft;
      w2 = sldivPosition.width + sldivPosition.marginLeft;
    }
    let timeLeft = orderUtil.formatMs(parseInt((w1/middleWidth)*(selEndTime - selStartTime)) + selStartTime);
    let timeRight = orderUtil.formatMs(parseInt((w2/middleWidth)*(selEndTime - selStartTime)) + selStartTime);
    let tmpArr = orderUtil.deepClone(points);
    let arr1 = [];
    let arr2 = [];
    for(let i=0; i<tmpArr.length; i++){
      let p = tmpArr[i];
      if(p.t >= timeLeft && p.t <= timeRight){
        arr1.push(p);
        arr2.push(i*34);
      }
    }
    if(arr1.length >=2 && arr2.length >=2){ //复制粘贴功能至少选中两个点
      setSelEditPointsArr(arr1);
      setBatchSelPointPositionArr(arr2);
    }
  }

  const [canvasMouseMoveXLeft, setCanvasMouseMoveXLeft] = useState(0);
  //当鼠标在canvas上摁下左键向右滑动到右侧控制球区域
  //则把线段选区范围选择到最右边的点，保证右侧曲线全选
  const mouseMoveToControlBoxArea = () => {
    if(mouseDownType === "left" && canvasMouseMoveXLeft > 500 && selEditPointsArr.length > 0){
      let tmpArr = [...points];
      let index = orderUtil.getPointIndex(tmpArr, selEditPointsArr[0].t);
      let tArr = tmpArr.splice(index);
      setSelEditPointsArr(tArr);
      let w = middleWidth - sldivPosition.marginLeft;
      let et = tmpArr[tmpArr.length-1].t;
      setSldivPosition({...sldivPosition,width:w,divEndTime:et});
      showCopyPoints(w, sldivPosition.marginLeft);
    }
  }
  //当鼠标在canvas上摁下左键向左滑动到左侧VibrationBox区域
  //则把线段选区范围选择到最左边的点，保证左侧曲线全选
  const mouseMoveToVibrationBoxArea = () => {
    if(mouseDownType === "left" && canvasMouseMoveXLeft < 100 && selEditPointsArr.length > 0){
      let tmpArr = [...points];
      let index = orderUtil.getPointIndex(tmpArr, selEditPointsArr[selEditPointsArr.length-1].t);
      let tArr = tmpArr.splice(0, index+1);
      setSelEditPointsArr(tArr);
      let marginLeft = sldivPosition.marginLeft;
      let w = sldivPosition.width + marginLeft;
      setSldivPosition({...sldivPosition,width:w,divStartTime:0,marginLeft:0});
      showCopyPoints(w, 0);
    }
  }

  useEffect(()=>{
    if(editorMode.edMode !== 2){ //编辑器模式：1创建，2编辑，3预览
      setSldivPosition({ width:0,marginLeft:0,divStartTime:0,divEndTime:0,show:false });
      setBatchSelPointPositionArr([]);
    }
  }, [editorMode]);
  useEffect(()=>{

    let ttt = null;

    //播放视频
    const onPlay = function(){
      let pt1 = parseInt(videoEl.currentTime*1000);
      setIsPlay(true);
      if(connectToyStatus.ctStatus === 3){
        let ts = (new Date().getTime()) + diffTime;
        let data = { videoTime:pt1,speed:playSpeed.speed,localTime: ts};
        let type = SocketEvent.StartWatchVideoStatusDTO;
        socketServiceInstanct.socketEmitMsg(type, data);
      }
      let ballImg = document.getElementById(lvsPatternEditorId + "_controlBallImg");
      if(ballImg){
        let bLevel = orderUtil.limitLevel(Math.ceil(20 - (ballImg.offsetTop - 52)/7));
        if(points.length === 0){
          let tmpArr = orderUtil.deepClone(points);
          tmpArr.push({t:0,v:bLevel});
          tmpArr.push({t:100,v:bLevel});
          tmpArr.push({t:200,v:bLevel});
          setLevel(bLevel);
          setPoints(tmpArr);
        }
      }
    }
    //暂停播放视频
    const onPause = function(){
      setIsPlay(false);
      clearInterval(vpsTimer);
      setVpsTimer(null);
      if(connectToyStatus.ctStatus === 3){
        let type = SocketEvent.StopWatchVideoStatusDTO;
        socketServiceInstanct.socketEmitMsg(type, {});
      }
      setSendVideoInfoTimer({hasViTimer:false});
    }
    //视频持续播放
    const timeUpdate = function(){
      if(isWaiting.waiting && isWaiting.t > 0){
        let now = new Date().getTime();
        if(now - isWaiting.t > 300){
          setIsWaiting({waiting:false,t:0});
          onPlay();
        }
      }
      let curPointTime = parseInt(videoEl.currentTime*1000);
      let pt = orderUtil.formatMs(curPointTime);
      setProgress(curPointTime);
      if(isPlay && editorMode.edMode === 1){
        //播放视频同时进行画线
        let tmpPointsArr = orderUtil.deepClone(points);
        let pointLength = tmpPointsArr.length;
        if(pointLength > 0){
          let lastPoint = tmpPointsArr[pointLength - 1];
          if(lastPoint.v === level){
            let newPoint = null;
            if(pointLength >1){
              //检测最后两个点是否强度相等
              if(tmpPointsArr[pointLength-1].v === tmpPointsArr[pointLength-2].v){
                setSameLevelTime(sameLevelTime => sameLevelTime+1);
                //在一些特殊时间点插入一些关键点，用于控制曲线不要回旋
                // if(sameLevelTime === 3 ||sameLevelTime === 6 || sameLevelTime === 12 || sameLevelTime === 30 || sameLevelTime === 60){
                //   newPoint = { t:pt,v:level };
                // }else if(sameLevelTime >= 100 && sameLevelTime%100===0){
                //   newPoint = { t:pt,v:level };
                // }
                if(sameLevelTime >= 3 && sameLevelTime%3===0){
                  newPoint = { t:pt,v:level };
                } else{
                  //其他时间，则更新最后一个点的时间即可，无须继续插入新点
                  if(pt > tmpPointsArr[pointLength-1].t){
                    tmpPointsArr[pointLength-1].t = pt;
                    let ballImg = document.getElementById(lvsPatternEditorId + "_controlBallImg");
                    if(ballImg){
                      let bLevel = orderUtil.limitLevel(Math.ceil(20 - (ballImg.offsetTop - 52)/7));
                      tmpPointsArr[pointLength-1].v = bLevel;
                      setLevel(bLevel);
                    }
                  }
                }
              }else{
                setSameLevelTime(0);
                newPoint = { t:pt,v:level };
              }
            }else{
              newPoint = { t:pt,v:level };
            }
            if(newPoint){
              if(newPoint.t > tmpPointsArr[pointLength-1].t){
                tmpPointsArr.push(newPoint);
              }
            }
            if(curPointTime - points[points.length - 1].t > 3000){
              //补点逻辑
              let lst = points[points.length - 1].t + 3000;
              let lsv = points[points.length - 1].v;
              let bdArr = [{t:lst, v:lsv}];
              while(curPointTime - bdArr[bdArr.length - 1].t > 3000){
                let xhTime = bdArr[bdArr.length - 1].t + 3000;
                let tp = {t:xhTime, v:lsv};
                bdArr.push(tp);
              }
              tmpPointsArr = tmpPointsArr.concat(bdArr);
            }
            //播放视频的时候再曲线末尾持续追加画线
            if(curPointTime > lastPoint.t - 300){
              setPoints(tmpPointsArr);
            }
          }
        }
      }
      if(isPlay && socketServiceInstanct && connectToyStatus.ctStatus === 3){
        if(!sendVideoInfoTimer.hasViTimer){
          ttt = setInterval(()=>{
            socketSendVideoInfo2();
            clearInterval(ttt);
            setVpsTimer(null);
            setSendVideoInfoTimer({hasViTimer:false});
          }, 1000); //5000
          setSendVideoInfoTimer({hasViTimer:true});
          setVpsTimer(ttt);
        }
      }
    }
    //播放卡顿
    const waiting = function(){
      //一个奇怪的问题：
      //当视频播放完毕后再点击播放按钮，此时video标签会先onPlay,再触发waiting
      //但是此时视频还是正常播放，而我却发送了暂停事件给服务端
      //故这里用播放进度>0才对waiting做处理
      if(videoEl.currentTime*1000 > 0){
        onPause();
        setIsWaiting({waiting:true,t:new Date().getTime()});
      }
    }
    const ratechange = function(){
      setPlaySpeed({speed:videoEl.playbackRate});
      socketSendVideoInfo2(0,videoEl.playbackRate)
    }
    if(videoEl){
      setTimeScaleInfo({
        selStartTime,
        selEndTime,
        selTime: (selEndTime - selStartTime),
        videoTotalTime,
        middleWidth,
        width: middleWidth, 
        slideBtn: "right"
      })
      videoEl.addEventListener('pause', onPause);        //暂停播放
      videoEl.addEventListener('play', onPlay);          //视频播放
      videoEl.addEventListener('timeupdate', timeUpdate);//播放进度实时更新
      videoEl.addEventListener('waiting', waiting);      //播放卡顿
      videoEl.addEventListener('ratechange', ratechange);      //播放速度改变
    }
    //发送视频播放信息
    const socketSendVideoInfo2 = function(t, cSpeed) {
      let vt = 0;
      if(t){
        vt = t;
      }else{
        vt = parseInt(videoEl.currentTime*1000);
      }
      let tmpSpeed = playSpeed.speed;
      if(cSpeed){
        tmpSpeed = cSpeed;
      }
      let localTime = (new Date().getTime()) + diffTime;
      let data = { videoTime:vt,speed:tmpSpeed,localTime: localTime};
      if(isPlay){
        let type = SocketEvent.VideoProgressStatusDTO;
        socketServiceInstanct.socketEmitMsg(type, data);
      }
    }
    const getReadyPatternEvent = (data) => {
      let t = parseInt(videoEl.currentTime*1000);
      let ts = (new Date().getTime()) + diffTime;
      let json = { videoTime:t,speed:playSpeed.speed,localTime:ts };
      if(isPlay){
        let type = SocketEvent.VideoProgressStatusDTO;
        socketServiceInstanct.socketEmitMsg(type, json);
      }
      let toysArr = [];
      let toysData = JSON.parse(data).toys;
      toysData.length&&toysData.forEach(item=>{
        item = JSON.parse(item)
        toysArr.push(item.name)
      })
      setToys(toysArr);
    }
    const exitPatternSyncEvent = (data) => {
      setConnectToyStatus({ctStatus:1});
      if(editorStatus.edStatus === 4){
        setEditorStatus({edStatus:1});
      }else if(editorMode.edMode === 3){ //退出编辑模式
        setEditorMode({edMode:1});
        setEditorStatus({edStatus:2}); //显示编辑器
      }
    }
    const remoteSyncStatusEvent = (data) => {
      // console.log("remote用户扫码并同意连接玩具！", data);
      let status = JSON.parse(data).status;
      if(status === 3){
        setQrCodeData(null);
        setConnectToyStatus({ctStatus:3});
        if (pf==="Audiodesires_demo") {
          setTimeout(() => {
            var hashH = document.documentElement.offsetHeight; //获取自身高度
            window.parent.postMessage(hashH, "*");
          }, 200);
        } 
        if(isPlay){
          let pt1 = parseInt(videoEl.currentTime*1000);
          let data = { videoTime:pt1,speed:playSpeed.speed,localTime:new Date().getTime() };
          let type = SocketEvent.StartWatchVideoStatusDTO;
          socketServiceInstanct.socketEmitMsg(type, data);
        }
        if(!isMobile && role === 1 && editorStatus.edStatus !== 2 && (videoHasPattern.hasPattern)){
          setEditorStatus({edStatus:4});
        }
        if(videoHasPattern.hasPattern){
          //bi日志埋点：连上玩具当做用户要播放该pattern
          let osInfo = orderUtil.getOsInfo();
          let param = JSON.stringify({
            videoId: videoId,
            pf: pf,
            uid: uid,
            videoUrl: window.location.href,
            system: osInfo.name + " " + osInfo.version,
            browser: osInfo.browser,
          });
          axios.post(Api.audienceRecord, param).then(function (res) {
            if(res.data && res.data.code === 0){ }
          });
        }
      }
      if(status === 3 && qrCodeData && qrCodeData.type === 1){  //创建者扫码连接成功，进入预览
        if(points.length > 0){
          if(qrCodeData.next === "preview"){
            // sendStartPreviewMode();
            uploadPattern(points, true);
            createRecord('preview_click');
          }
        }
      }else if(status === 3 && qrCodeData && qrCodeData.type === 2){  //普通用户扫码连接成功 显示同步控制状态
        setEditorStatus({edStatus:4});
        if(editorMode.edMode === 3){
          sendStartPreviewMode();
        }
      }else if(status === 3 && !qrCodeData){
        // if(editorStatus.edStatus === 2){
        //   setEditorMode({edMode:1});     //退出预览
        // }else{
        //   if(role === 1){
        //     if(editorStatus.edStatus === 2){
        //       setEditorMode({edMode:1});
        //     }
        //   }else{
        //     setEditorStatus({edStatus:4});
        //   }
        // }
      }else if(status === 4){
        setTimeout(()=>{
          setConnectToyStatus({ctStatus:1});
        }, 2500);
      }
    }
    const sendStartPreviewMode = () => {
      let isDownload = true;
      let str1 = JSON.stringify(points);
      let str2 = JSON.stringify(backupPoints);
      if((str1 === str2 || backupPoints.length === 0) && hasSubmitPattern){
        // isDownload = false;
        isDownload = true; //123
      }
      let data = { pattern:patternInfo.url, status:true, isDownload:isDownload };
      socketServiceInstanct.socketEmitMsg(SocketEvent.StartPreviewModeDTO, data);  
    }
    const getVideoProgressEvent = (data) => {
      let t = parseInt(videoEl.currentTime*1000);
      let ts = (new Date().getTime()) + diffTime;
      let json = { videoTime:t,speed:playSpeed.speed,localTime:ts };
      if(isPlay){
        let type = SocketEvent.VideoProgressStatusDTO;
        socketServiceInstanct.socketEmitMsg(type, json);
      }
    }
    //查询当前用户的连接状态 1未连接 2连接中 3已连接
    const getSyncStatusEvent = (data) => {
      if(data.status === 3){
        setFollowPattern({follow:true});
        setConnectToyStatus({ctStatus:3});
      }else{
        setFollowPattern({follow:false});
        setConnectToyStatus({ctStatus:1});
        if(editorStatus.edStatus === 4){
          setEditorStatus({edStatus:1});
        }
      }
      if(!isMobile && data.status === 3 && data.type === 1){ //点击play按钮主动查询跟随状态返回的结果
        setQrCodeData(null);
        setConnectToyStatus({ctStatus:3});
        setEditorStatus({edStatus:4});
      }
    }
    const disconnectPatternSyncEvent = (data) => {
      setConnectToyStatus({ctStatus:4});
      if(editorMode.edMode === 3){ //预览模式
        setEditorMode({edMode:1});     //退出预览
        setEditorStatus({edStatus:2}); //显示编辑器
      }else{
        setEditorStatus({edStatus:1});  //显示按钮
      }
    }
    //用户切换pattern
    const SyncPatternStatusChangeEvent = (data) => {
      const obj = JSON.parse(data);
      setFollowPattern({follow: obj.status});
      if(!obj.status){
        setConnectToyStatus({ctStatus:1}); //断开连接（未连接）
        if(editorMode.edMode === 3){ //预览模式
          setEditorStatus({edStatus:2}); //显示编辑器
        }
      }else{
        setConnectToyStatus({ctStatus:3}); //连接中
      }
    }
    //remote在同步过程中下载pattern失败的通知事件
    const errorSyncPatternEvent = (data) => {
      const obj = JSON.parse(data);
      setRemoteDnPattern({rdnStatus:2,videoId:obj.videoId});
    }
    const SocketDisconnectEvent = (data) => {
      if(connectToyStatus.ctStatus === 3){
        setConnectToyStatus({ctStatus:5}); //app异常断开连接
      }
      if(editorMode.edMode === 3){ //预览模式
        setEditorMode({edMode:1});     //退出预览
        setEditorStatus({edStatus:2}); //显示编辑器
      }
    }
    const VideoPreviewStatusEvent = (data) => {//切换视频时记住预览状态
      const obj = JSON.parse(data);
      console.log("VideoPreviewStatus",obj.status);
      if (obj.status) {
        setEditorMode({edMode:3});  //预览模式
      }else{
        setEditorMode({edMode:1});
      }
    }
    const SetPlaySpeedEvent = (data) => {
      let tmpSpeed = data.speed;
      setPlaySpeed({speed:tmpSpeed});
      videoEl.playbackRate = Number(tmpSpeed);
      socketSendVideoInfo2(0, tmpSpeed);
      console.log('SetPlaySpeedEvent');
    }
    //监听socket消息
    if(socketServiceInstanct){
      if(!socketServiceInstanct._events.GetReadyPatternDTO){
        socketServiceInstanct.on(SocketEvent.GetReadyPatternDTO, getReadyPatternEvent);
      }
      if(!socketServiceInstanct._events.GetSyncStatusDTO){
        socketServiceInstanct.on(SocketEvent.GetSyncStatusDTO, getSyncStatusEvent);
      }
      if(!socketServiceInstanct._events.ExitPatternSyncDTO){
        socketServiceInstanct.on(SocketEvent.ExitPatternSyncDTO, exitPatternSyncEvent);
      }
      if(!socketServiceInstanct._events.RemoteSyncStatusDTO){
        socketServiceInstanct.on(SocketEvent.RemoteSyncStatusDTO, remoteSyncStatusEvent);
      }
      if(!socketServiceInstanct._events.GetVideoProgressDTO){
        socketServiceInstanct.on(SocketEvent.GetVideoProgressDTO, getVideoProgressEvent);
      }
      if(!socketServiceInstanct._events.ErrorSyncPatternDTO){
        socketServiceInstanct.on(SocketEvent.ErrorSyncPatternDTO, errorSyncPatternEvent);
      }
      if(!socketServiceInstanct._events.DisconnectPatternSyncDTO){
        socketServiceInstanct.on(SocketEvent.DisconnectPatternSyncDTO, disconnectPatternSyncEvent);
      }
      if(!socketServiceInstanct._events.SyncPatternStatusChangeDTO){
        socketServiceInstanct.on(SocketEvent.SyncPatternStatusChangeDTO, SyncPatternStatusChangeEvent);
      }
      if(!socketServiceInstanct._events.SocketDisconnectDTO){
        socketServiceInstanct.on(SocketEvent.SocketDisconnectDTO, SocketDisconnectEvent);
      }
      if(!socketServiceInstanct._events.VideoPreviewStatusDTO){
        socketServiceInstanct.on(SocketEvent.VideoPreviewStatusDTO, VideoPreviewStatusEvent);
      }
    }
    if(!socketServiceInstanct._events.SetPlaySpeedDTO){
      socketServiceInstanct.on(SocketEvent.SetPlaySpeedDTO, SetPlaySpeedEvent);
    }
    return function(){
      clearInterval(ttt);
      clearInterval(vpsTimer);
      setVpsTimer(null);
      if(videoEl){
        videoEl.removeEventListener('play', onPlay);
        videoEl.removeEventListener('pause', onPause);
        videoEl.removeEventListener('timeupdate', timeUpdate);
        videoEl.removeEventListener('waiting', waiting);
        videoEl.removeEventListener('ratechange', ratechange);
      }
      if(socketServiceInstanct){
        socketServiceInstanct.off(SocketEvent.GetReadyPatternDTO, getReadyPatternEvent);
        socketServiceInstanct.off(SocketEvent.ExitPatternSyncDTO, exitPatternSyncEvent);
        socketServiceInstanct.off(SocketEvent.RemoteSyncStatusDTO, remoteSyncStatusEvent);
        socketServiceInstanct.off(SocketEvent.GetVideoProgressDTO, getVideoProgressEvent);
        socketServiceInstanct.off(SocketEvent.GetSyncStatusDTO, getSyncStatusEvent);
        socketServiceInstanct.off(SocketEvent.ErrorSyncPatternDTO, errorSyncPatternEvent);
        socketServiceInstanct.off(SocketEvent.DisconnectPatternSyncDTO, disconnectPatternSyncEvent);
        socketServiceInstanct.off(SocketEvent.SyncPatternStatusChangeDTO, SyncPatternStatusChangeEvent);
        socketServiceInstanct.off(SocketEvent.SocketDisconnectDTO, SocketDisconnectEvent);
        socketServiceInstanct.off(SocketEvent.VideoPreviewStatusDTO, VideoPreviewStatusEvent);
      }
      socketServiceInstanct.off(SocketEvent.SetPlaySpeedDTO, SetPlaySpeedEvent);
    }
  }, [middleWidth,selEndTime,selStartTime,videoTotalTime,videoEl,editorStatus,role,isMobile,followPattern,hasSubmitPattern,
    level,points,isPlay,sameLevelTime,editorMode,qrCodeData,backupPoints,patternInfo,uid,editorWidth,isWaiting,evokeAppUrl,
    sendVideoInfoTimer,connectToyStatus,pf,videoId,lvsPatternEditorId,socketServiceInstanct,msgConfig,playSpeed,vpsTimer,diffTime,
    createRecord,uploadPattern,videoHasPattern]);

  return (
    <>
    {
      isMobile ?
      <div className='lvsMoPattern lvsPatternEditor'>
        
        {
          (videoHasPattern && videoHasPattern.hasPattern) ?
          <>
            {
              editorStatus.edStatus === 1&&pf === "Audiodesires_demo" ?
              <>
              {
                followPattern.follow ?
                <div className='syncBtn3' onClick={exitSync}>{t("exomoon.audiodesires.text9")}</div>
                :
                <>
                  {
                    evokeAppUrl.evokeUrl ?
                    <a className='syncBtn3' href={evokeAppUrl.evokeUrl} target="_blank" rel="noopener noreferrer">{t("bloom.v3.text21")}</a>
                    :
                    <div className='syncBtn3'>{t("bloom.v3.text21")}</div>
                  }
                </>
              }
              </>: ""
            }
            {
              connectToyStatus.ctStatus === 1&&pf !== "Audiodesires_demo" ?
              <>
              {
                followPattern.follow ?
                <div className='syncBtn' onClick={playPattern}>{t("SyncToy")}</div>
                :
                <>
                  {
                    evokeAppUrl.evokeUrl ?
                    <a className='syncBtn' href={evokeAppUrl.evokeUrl} target="_blank" rel="noopener noreferrer">{t("SyncToy")}</a>
                    :
                    <div className='syncBtn'>{t("SyncToy")}</div>
                  }
                </>
              }
              </> : ""
            }
            {
              connectToyStatus.ctStatus === 3&&pf !== "Audiodesires_demo" ?
              <div>
                <div className='syncBtn2'>{t("syncing")}</div>
                <div className='endBtn' onClick={exitSync}>{t("end")}</div>
              </div> : ""
            }
            {
              connectToyStatus.ctStatus === 4&&pf !== "Audiodesires_demo"  ?
              <div>
                <div className='discBtn'>{t("disconnect")}</div>
                <a className='syncAgain' href={evokeAppUrl.evokeUrl} target="_blank" rel="noopener noreferrer">{t("syncAgain")}</a>
              </div> : ""
            }
            {
              connectToyStatus.ctStatus === 5&&pf !== "Audiodesires_demo"  ?
              <div>
                <div className='discBtn'>{t("disconnectApp")}</div>
                <a className='syncAgain' href={evokeAppUrl.evokeUrl} target="_blank" rel="noopener noreferrer">{t("syncAgain")}</a>
              </div> : ""
            }
          </> : ""
        }
        {
          (videoHasPattern && (!videoHasPattern.hasPattern) && followPattern.follow) ?
          <div>
            <div className='discBtn'>{t("lsUnsupport")}</div>
            <div className='endBtn' onClick={exitSync}>{t("end")}</div>
          </div> : ""
        }
      </div> : ""
    }
    {
      isMobile ? "" : 
      <>
        <div className='lvsPatternEditor' id={lvsPatternEditorId} style={ Css.lvsEditor(editorWidth) }>
        {
          editorStatus.edStatus === 1&&pf === "Audiodesires_demo" ?
          <div className='pcBtnArea2'>
            {
              editor_status?<div className='playBtn2' onClick={showEditor}>{t("editPattern")}</div>:""
            }
            <div className='playBtn2' onClick={playPattern}>{t("bloom.v3.text21")}</div>
          </div>
          : ""
        }
        {
          editorStatus.edStatus === 1&&pf !== "Audiodesires_demo" ?
          <div className='pcBtnArea'>
            {
              patternInfo.id ?  //存在pattern
              <>
                {
                  role === 1 ? //创作者：编辑和播放pattern
                  <>
                    <div className='createBtn' onClick={showEditor}>{t("editPattern")}</div>
                    <div className='playBtn' onClick={playPattern}>{t("SyncToy")}</div>
                  </>
                  :
                  //普通用户显示播放pattern
                  <div className='playBtn' onClick={playPattern}>{t("SyncToy")}</div>
                }
              </>
              :
              <>
                {
                  role === 1 ? //不存在pattern 创作者：新建pattern
                  <div className='createBtn' onClick={showEditor}>{t("createPattern")}</div> : "" //普通用户显示不支持pattern
                }
              </>
            }
          </div> : ""
        }
        {
          editorStatus.edStatus === 2 && role === 1 ?
          <div style={ Css.editorArea(editorWidth) }>
            <TopMenu 
              data={{ points,connectToyStatus,middleWidth,editorMode,editorWidth,pf }}
              method={{connectToyEvent,goPreview,goEdit,showSubmitDia,exitEdit,closeEditor}}>
            </TopMenu>
            <VibrationBox 
              data={{videoEl,leftWidth}}
              method={{mouseMoveToVibrationBoxArea}}>
            </VibrationBox>
            <div id={lvsPatternEditorId + '-control-area'}>
              <PatternBox 
                data={{
                  points,middleWidth,videoEl,lvsPatternEditorId,editorMode,editPointPositionArr,
                  batchSelPointPositionArr,timeScaleInfo,sldivPosition,progress,copyArr,editMenuInfo,videoTotalTime,
                  isSelectLine,selStartTime,selEndTime,timeLinePosition,selEditPointsArr,mouseDownType
                }}
                method={{
                  setCopyArr,pauseVideo,setPoints,setSelEditPointsArr,setBatchSelPointPositionArr,setCanvasMouseMoveXLeft,
                  hideCopyPaste,setMouseDownType,setEditPointPositionArr,setEditMenuInfo,setIsSelectLine,showCopyPoints,
                  setSldivPosition,setTimeLinePosition,setSelStartTime,setSelEndTime,setTimeScaleInfo
                }}
              ></PatternBox>
              <ControlBox
                method={{setLevelRange,setLevel,setPoints,pauseVideo,mouseMoveToControlBoxArea}}
                data={{level,editorMode,levelRange,points,progress,videoEl,isPlay,sameLevelTime,lvsPatternEditorId}}
              ></ControlBox>
            </div>
            <Confirm dialogConfig={{dialogConfig}} method={{confirmYes,confirmCancel,confirmExit}}></Confirm>
          </div> : ""
          }
          {
            qrCodeData ? 
            <QrCode data={{qrCodeData,editorWidth}} method={{closeQrCode}}></QrCode> : ""
          }
          {
            editorStatus.edStatus === 4 ?
            <UnSync data={{ editorWidth,toys,remoteDnPattern,pf }} method={{retrySync,exitSync}}></UnSync> : ""
          }
          {
            (msgConfig && msgConfig.msg) ?
            <Message msgConfig={msgConfig} method={{closeMsg,closeAndExit}}></Message> : ""
          }
        </div>
      </>
    }
    </>
  );
}

export default Editor;